import { Component, OnInit } from '@angular/core'

@Component({
    selector: './parabolic-dish',
    templateUrl: './parabolic-dish.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class ParabolicDishComponent implements OnInit {

    ngOnInit() {

    }
}